"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Text = _interopRequireDefault(require("../Text/Text"));
const ErrorIcon = _styledComponents.default.span.withConfig({
  displayName: "ErrorText__ErrorIcon",
  componentId: "sc-19bj17r-0"
})(["display:inline-block;width:100%;z-index:1;font-weight:bold;padding:0.6rem 0 1rem;"]);
const ErrorText = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Text.default, Object.assign({}, rest, {
    color: "red"
  }), /*#__PURE__*/_react.default.createElement(ErrorIcon, null, children));
};
var _default = exports.default = ErrorText;